import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthStore } from '../store/auth.store';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private _authStore: AuthStore, private _router: Router) {}

  canActivate(): boolean {
    if (this._authStore.closingSession()) {
      return true; // Allow access to login page if closingSession is true
    }

    if (this._authStore.isAuthenticated()) {
      this._router.navigateByUrl('/'); // Redirect to home or dashboard if logged in
      return false;
    }

    return true; // Allow access to login page if not logged in
  }
}
